
//================================//
/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

(function () {
  const moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  var formatMoney = function(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || moneyFormat;

    function formatWithDelimiters(
      number,
      precision = 2,
      thousands = ',',
      decimal = '.'
    ) {
      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      const parts = number.split('.');
      const dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        `$1${thousands}`
      );
      const centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  window.formatMoney = formatMoney;
})();
//=============currency.js=end==================//
(function () {
  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function() {
        try {
          new Blob()
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue + ', ' + value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) {
      items.push(name)
    })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) {
      items.push(value)
    })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) {
      items.push([name, value])
    })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      /*
        fetch-mock wraps the Response object in an ES6 Proxy to
        provide useful test harness features such as flush. However, on
        ES5 browsers without fetch or Proxy support pollyfills must be used;
        the proxy-pollyfill is unable to proxy an attribute unless it exists
        on the object before the Proxy is created. This change ensures
        Response.bodyUsed exists on the instance, while maintaining the
        semantic of setting Request.bodyUsed in the constructor before
        _initBody is called.
      */
      this.bodyUsed = this.bodyUsed
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        this._bodyText = body = Object.prototype.toString.call(body)
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      this.signal = input.signal
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'same-origin'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.signal = options.signal || this.signal
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, {body: this._bodyInit})
  }

  function decode(body) {
    var form = new FormData()
    body
      .trim()
      .split('&')
      .forEach(function(bytes) {
        if (bytes) {
          var split = bytes.split('=')
          var name = split.shift().replace(/\+/g, ' ')
          var value = split.join('=').replace(/\+/g, ' ')
          form.append(decodeURIComponent(name), decodeURIComponent(value))
        }
      })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = options.status === undefined ? 200 : options.status
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : ''
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  var DOMException = self.DOMException
  try {
    new DOMException()
  } catch (err) {
    DOMException = function(message, name) {
      this.message = message
      this.name = name
      var error = Error(message)
      this.stack = error.stack
    }
    DOMException.prototype = Object.create(Error.prototype)
    DOMException.prototype.constructor = DOMException
  }

  function fetch(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)

      if (request.signal && request.signal.aborted) {
        return reject(new DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest()

      function abortXhr() {
        xhr.abort()
      }

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        setTimeout(function() {
          resolve(new Response(body, options))
        }, 0)
      }

      xhr.onerror = function() {
        setTimeout(function() {
          reject(new TypeError('Network request failed'))
        }, 0)
      }

      xhr.ontimeout = function() {
        setTimeout(function() {
          reject(new TypeError('Network request failed'))
        }, 0)
      }

      xhr.onabort = function() {
        setTimeout(function() {
          reject(new DOMException('Aborted', 'AbortError'))
        }, 0)
      }

      function fixUrl(url) {
        try {
          return url === '' && self.location.href ? self.location.href : url
        } catch (e) {
          return url
        }
      }

      xhr.open(request.method, fixUrl(request.url), true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false
      }

      if ('responseType' in xhr) {
        if (support.blob) {
          xhr.responseType = 'blob'
        } else if (
          support.arrayBuffer &&
          request.headers.get('Content-Type').indexOf('application/octet-stream') !== -1
        ) {
          xhr.responseType = 'arraybuffer'
        }
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr)

        xhr.onreadystatechange = function() {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr)
          }
        }
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }

  fetch.polyfill = true

  if (!self.fetch) {
    self.fetch = fetch
    self.Headers = Headers
    self.Request = Request
    self.Response = Response
  }

  window.Headers = Headers;
  window.Request = Request;
  window.Response = Response;
  window.fetch = fetch;
})();


//===============window.fetch.js=end================//
// get successful control from form and assemble into object
// http://www.w3.org/TR/html401/interact/forms.html#h-17.13.2

(function () {
    // types which indicate a submit action and are not successful controls
    // these will be ignored
    var k_r_submitter = /^(?:submit|button|image|reset|file)$/i;

    // node names which could be successful controls
    var k_r_success_contrls = /^(?:input|select|textarea|keygen)/i;

    // Matches bracket notation.
    var brackets = /(\[[^\[\]]*\])/g;

    // serializes form fields
    // @param form MUST be an HTMLForm element
    // @param options is an optional argument to configure the serialization. Default output
    // with no options specified is a url encoded string
    //    - hash: [true | false] Configure the output type. If true, the output will
    //    be a js object.
    //    - serializer: [function] Optional serializer function to override the default one.
    //    The function takes 3 arguments (result, key, value) and should return new result
    //    hash and url encoded str serializers are provided with this module
    //    - disabled: [true | false]. If true serialize disabled fields.
    //    - empty: [true | false]. If true serialize empty fields
    function serialize(form, options) {
        if (typeof options != 'object') {
            options = { hash: !!options };
        }
        else if (options.hash === undefined) {
            options.hash = true;
        }

        var result = (options.hash) ? {} : '';
        var serializer = options.serializer || ((options.hash) ? hash_serializer : str_serialize);

        var elements = form && form.elements ? form.elements : [];

        //Object store each radio and set if it's empty or not
        var radio_store = Object.create(null);

        for (var i=0 ; i<elements.length ; ++i) {
            var element = elements[i];

            // ingore disabled fields
            if ((!options.disabled && element.disabled) || !element.name) {
                continue;
            }
            // ignore anyhting that is not considered a success field
            if (!k_r_success_contrls.test(element.nodeName) ||
                k_r_submitter.test(element.type)) {
                continue;
            }

            var key = element.name;
            var val = element.value;

            // we can't just use element.value for checkboxes cause some browsers lie to us
            // they say "on" for value when the box isn't checked
            if ((element.type === 'checkbox' || element.type === 'radio') && !element.checked) {
                val = undefined;
            }

            // If we want empty elements
            if (options.empty) {
                // for checkbox
                if (element.type === 'checkbox' && !element.checked) {
                    val = '';
                }

                // for radio
                if (element.type === 'radio') {
                    if (!radio_store[element.name] && !element.checked) {
                        radio_store[element.name] = false;
                    }
                    else if (element.checked) {
                        radio_store[element.name] = true;
                    }
                }

                // if options empty is true, continue only if its radio
                if (val == undefined && element.type == 'radio') {
                    continue;
                }
            }
            else {
                // value-less fields are ignored unless options.empty is true
                if (!val) {
                    continue;
                }
            }

            // multi select boxes
            if (element.type === 'select-multiple') {
                val = [];

                var selectOptions = element.options;
                var isSelectedOptions = false;
                for (var j=0 ; j<selectOptions.length ; ++j) {
                    var option = selectOptions[j];
                    var allowedEmpty = options.empty && !option.value;
                    var hasValue = (option.value || allowedEmpty);
                    if (option.selected && hasValue) {
                        isSelectedOptions = true;

                        // If using a hash serializer be sure to add the
                        // correct notation for an array in the multi-select
                        // context. Here the name attribute on the select element
                        // might be missing the trailing bracket pair. Both names
                        // "foo" and "foo[]" should be arrays.
                        if (options.hash && key.slice(key.length - 2) !== '[]') {
                            result = serializer(result, key + '[]', option.value);
                        }
                        else {
                            result = serializer(result, key, option.value);
                        }
                    }
                }

                // Serialize if no selected options and options.empty is true
                if (!isSelectedOptions && options.empty) {
                    result = serializer(result, key, '');
                }

                continue;
            }

            result = serializer(result, key, val);
        }

        // Check for all empty radio buttons and serialize them with key=""
        if (options.empty) {
            for (var key in radio_store) {
                if (!radio_store[key]) {
                    result = serializer(result, key, '');
                }
            }
        }

        return result;
    }

    function parse_keys(string) {
        var keys = [];
        var prefix = /^([^\[\]]*)/;
        var children = new RegExp(brackets);
        var match = prefix.exec(string);

        if (match[1]) {
            keys.push(match[1]);
        }

        while ((match = children.exec(string)) !== null) {
            keys.push(match[1]);
        }

        return keys;
    }

    function hash_assign(result, keys, value) {
        if (keys.length === 0) {
            result = value;
            return result;
        }

        var key = keys.shift();
        var between = key.match(/^\[(.+?)\]$/);

        if (key === '[]') {
            result = result || [];

            if (Array.isArray(result)) {
                result.push(hash_assign(null, keys, value));
            }
            else {
                // This might be the result of bad name attributes like "[][foo]",
                // in this case the original `result` object will already be
                // assigned to an object literal. Rather than coerce the object to
                // an array, or cause an exception the attribute "_values" is
                // assigned as an array.
                result._values = result._values || [];
                result._values.push(hash_assign(null, keys, value));
            }

            return result;
        }

        // Key is an attribute name and can be assigned directly.
        if (!between) {
            result[key] = hash_assign(result[key], keys, value);
        }
        else {
            var string = between[1];
            // +var converts the variable into a number
            // better than parseInt because it doesn't truncate away trailing
            // letters and actually fails if whole thing is not a number
            var index = +string;

            // If the characters between the brackets is not a number it is an
            // attribute name and can be assigned directly.
            if (isNaN(index)) {
                result = result || {};
                result[string] = hash_assign(result[string], keys, value);
            }
            else {
                result = result || [];
                result[index] = hash_assign(result[index], keys, value);
            }
        }

        return result;
    }

    // Object/hash encoding serializer.
    function hash_serializer(result, key, value) {
        var matches = key.match(brackets);

        // Has brackets? Use the recursive assignment function to walk the keys,
        // construct any missing objects in the result tree and make the assignment
        // at the end of the chain.
        if (matches) {
            var keys = parse_keys(key);
            hash_assign(result, keys, value);
        }
        else {
            // Non bracket notation can make assignments directly.
            var existing = result[key];

            // If the value has been assigned already (for instance when a radio and
            // a checkbox have the same name attribute) convert the previous value
            // into an array before pushing into it.
            //
            // NOTE: If this requirement were removed all hash creation and
            // assignment could go through `hash_assign`.
            if (existing) {
                if (!Array.isArray(existing)) {
                    result[key] = [ existing ];
                }

                result[key].push(value);
            }
            else {
                result[key] = value;
            }
        }

        return result;
    }

    // urlform encoding serializer
    function str_serialize(result, key, value) {
        // encode newlines as \r\n cause the html spec says so
        value = value.replace(/(\r)?\n/g, '\r\n');
        value = encodeURIComponent(value);

        // spaces should be '+' rather than '%20'.
        value = value.replace(/%20/g, '+');
        return result + (result ? '&' : '') + encodeURIComponent(key) + '=' + value;
    }

    window.serialize = serialize;
})();


//===============form-serialize.js=ens================//

//===============gocart.js=start================//

/*!
 * 
 *   @bornfight/gocart v1.0.9
 *   
 * 
 *   Copyright (c) Bornfight (https://www.bornfight.com/)
 * 
 *   This source code is licensed under the MIT license found in the
 *   LICENSE file in the root directory of this source tree.
 *  Add Multiple Triggers
 *   
 */


class GoCart {

  constructor(options) {

      const defaults = {
          cartModalFail: '.js-go-cart-modal-fail',
          cartModalFailClose: '.js-go-cart-modal-fail-close',
          cartModal: '.js-go-cart-modal',
          cartModalClose: '.js-go-cart-modal-close',
          cartModalContent: '.js-go-cart-modal-content',
          cartDrawer: '.js-go-cart-drawer',
          cartDrawerContent: '.js-go-cart-drawer-content',
          cartDrawerSubTotal: '.js-go-cart-drawer-subtotal',
          cartDrawerFooter: '.js-go-cart-drawer-footer',
          cartDrawerClose: '.js-go-cart-drawer-close',
          cartMiniCart: '.js-go-cart-mini-cart',
          cartMiniCartContent: '.js-go-cart-mini-cart-content',
          cartMiniCartSubTotal: '.js-go-cart-mini-cart-subtotal',
          cartMiniCartFooter: '.js-go-cart-mini-cart-footer',
          cartTrigger: '.js-go-cart-trigger',
          cartOverlay: '.js-go-cart-overlay',
          cartCount: '.js-go-cart-counter',
          addToCart: '.js-go-cart-add-to-cart',
          removeFromCart: '.js-go-cart-remove-from-cart',
          removeFromCartNoDot: 'js-go-cart-remove-from-cart',
          itemQuantity: '.js-go-cart-quantity',
          itemQuantityPlus: '.js-go-cart-quantity-plus',
          itemQuantityMinus: '.js-go-cart-quantity-minus',
          cartCheckout: '.js-go-checkout__button',
          cartMode: 'drawer',
          drawerDirection: 'right',
          displayModal: false,
					fetchCartComplete: 'fetch-cart-complete',
          // eslint-disable-next-line no-template-curly-in-string
          moneyFormat: '${{amount}}',
          labelAddedToCart: 'was added to your cart.',
          labelCartIsEmpty: 'Your Cart is currently empty!',
          labelQuantity: 'Quantity:',
          labelRemove: 'Remove',
          // Shipping Bar
          freeShippingBar: '.cart-free-shipping span',
          shippingBarTxt : '.cart-more-shipping',
          cartCountNum : '.cart-count-num',
          // Variants 
          goCartItemVariant: ".js-go-cart-item__variant",
      };

      this.defaults = Object.assign({}, defaults, options);

      this.cartModalFail = document.querySelector(this.defaults.cartModalFail);
      this.cartModalFailClose = document.querySelector(this.defaults.cartModalFailClose);
      this.cartModal = document.querySelector(this.defaults.cartModal);
      this.cartModalClose = document.querySelectorAll(this.defaults.cartModalClose);
      this.cartModalContent = document.querySelector(this.defaults.cartModalContent);
      this.cartDrawer = document.querySelector(this.defaults.cartDrawer);
      this.cartDrawerContent = document.querySelector(this.defaults.cartDrawerContent);
      this.cartDrawerSubTotal = document.querySelector(this.defaults.cartDrawerSubTotal);
      this.cartDrawerFooter = document.querySelector(this.defaults.cartDrawerFooter);
      this.cartDrawerClose = document.querySelector(this.defaults.cartDrawerClose);
      this.cartMiniCart = document.querySelector(this.defaults.cartMiniCart);
      this.cartMiniCartContent = document.querySelector(this.defaults.cartMiniCartContent);
      this.cartMiniCartSubTotal = document.querySelector(this.defaults.cartMiniCartSubTotal);
      this.cartMiniCartFooter = document.querySelector(this.defaults.cartMiniCartFooter);
      this.cartTrigger = document.querySelectorAll(this.defaults.cartTrigger);
      this.cartOverlay = document.querySelector(this.defaults.cartOverlay);
      this.cartCount = document.querySelector(this.defaults.cartCount);
      this.addToCart = document.querySelectorAll(this.defaults.addToCart);
      this.removeFromCart = this.defaults.removeFromCart;
      this.removeFromCartNoDot = this.defaults.removeFromCartNoDot;
      this.itemQuantity = this.defaults.itemQuantity;
      this.itemQuantityPlus = this.defaults.itemQuantityPlus;
      this.itemQuantityMinus = this.defaults.itemQuantityMinus;
      this.cartMode = this.defaults.cartMode;
      this.drawerDirection = this.defaults.drawerDirection;
      this.displayModal = this.defaults.displayModal;
      this.moneyFormat = this.defaults.moneyFormat;
      this.labelAddedToCart = this.defaults.labelAddedToCart;
      this.labelCartIsEmpty = this.defaults.labelCartIsEmpty;
      this.labelQuantity = this.defaults.labelQuantity;
      this.labelRemove = this.defaults.labelRemove;
      this.freeShippingBar = this.defaults.freeShippingBar;
      this.shippingBarTxt = this.defaults.shippingBarTxt;
      this.cartCountNum = this.defaults.cartCountNum;
      this.goCartItemVariant = this.defaults.goCartItemVariant;
      this.cartCheckout = document.querySelector(this.defaults.cartCheckout);

      this.init();

  }

  get isDrawerMode() {
      return this.cartMode === 'drawer';
  }

  init() {
			this.createCustomEmitter();
      this.fetchCart();

      if (this.isDrawerMode) {
          this.setDrawerDirection();
      }

      document.addEventListener('click', (event) => {
          if (event.target.matches(this.defaults.addToCart)) { 
              event.preventDefault();
              let item = event.target;
              let form = item.parentNode;
              while ('form' !== form.tagName.toLowerCase()) {
                  form = form.parentNode;
              }
              const formID = form.getAttribute('id');
              this.addItemToCart(formID);
          }
      }, false);
    
          // -----------//
   
    
          this.addToCart.forEach((item) => {
          item.addEventListener('click', (event) => {
          event.preventDefault(); 
              let item = event.target;
              let form = item.parentNode;
              while ('form' !== form.tagName.toLowerCase()) {
                  form = form.parentNode;
              }
              const formID = form.getAttribute('id');
              this.addItemToCart(formID); 
          });
          });
    
          // -------------//
    
      this.cartTrigger.forEach((item) => {
          item.addEventListener('click', (evt) => {
              evt.preventDefault();
              if (this.isDrawerMode) {
                  this.openCartDrawer();
              } else {
                  this.openMiniCart();
              }
              this.openCartOverlay();
          });
      });


      this.cartOverlay.addEventListener('click', () => {
          this.closeFailModal();
          this.closeCartModal();
          if (this.isDrawerMode) {
              this.closeCartDrawer();
          } else {
              this.closeMiniCart();
          }
          this.closeCartOverlay();
      });

      if (this.isDrawerMode) {
          this.cartDrawerClose.addEventListener('click', () => {
              this.closeCartDrawer();
              this.closeCartOverlay();
          });
      }

      if (this.displayModal) {
          this.cartModalClose.forEach((item) => {
              item.addEventListener('click', () => {
                  this.closeFailModal();
                  this.closeCartModal();
                  if (this.isDrawerMode) {
                      this.closeCartDrawer();
                  } else {
                      this.closeMiniCart();
                  }
                  this.closeCartOverlay();
              });
          });
      }

      if (this.cartCheckout) { 
        this.cartCheckout.addEventListener('click', (event) => { 
            event.preventDefault()

            this.redirectToReChargeCheckout()
        })
      }

      this.cartModalFailClose.addEventListener('click', () => {
          this.closeFailModal();
          this.closeCartModal();
          if (this.isDrawerMode) {
              this.closeCartDrawer();
          } else {
              this.closeMiniCart();
          }
          this.closeCartOverlay();
      });

  }

  fetchCart(callback) {
      window.fetch('/cart?view=json', {
          credentials: 'same-origin',
          method: 'GET',
      })
          .then((response) => response.text())
          .then((cart) => { 
						eval(cart); 
						this.fetchHandler(window.cart, callback); 
						document.dispatchEvent(this.fetchCartComplete);
					})
          .catch((error) => {
              console.error(error);
              this.ajaxRequestFail();
              throw new Error(error);
          });
  }

  addItemToCart(formID) {
      const form = document.querySelector(`#${formID}`);
      const formData = serialize(form, {hash: true});
      window.fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'include',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
      })
          .then((response) => response.json())
          .then((product) => this.addItemToCartHandler(product))
          .catch((error) => {
              this.ajaxRequestFail();
              throw new Error(error);
          });
  }

  removeItem(line) {
      const quantity = 0;
      window.fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          body: JSON.stringify({quantity, line}),
          headers: {
              'Content-Type': 'application/json',
          },
      })
          .then((response) => response.json())
          .then(() => this.fetchCart())
          .catch((error) => {
              this.ajaxRequestFail();
              throw new Error(error);
          });
  }

  redirectToReChargeCheckout() { 
    if ( window.cart && ! window.cart.has_subscription_products ) {
        // Using old primal's redirect to get auto discount code to be applied
        SubscriptionManager.saveCartAndRedirect()
        return
    }

    var checkout_url = 'https://checkout.rechargeapps.com/r/checkout?',
        url_params = [
            'myshopify_domain=' + Shopify.shop,
        ],
        cart_token = [],
        ga_linker = [];

    try {
        cart_token = ['cart_token=' + (document.cookie.match('(^|; )cart=([^;]*)')||0)[2]]
        ga_linker = [ga.getAll()[0].get('linkerParam')]
    } catch (e) { 
    }

    url_params = url_params.concat(cart_token).concat(ga_linker)

    window.location.href = checkout_url + url_params.join('&')
  }

  changeItemQuantity(line, quantity) {
      window.fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          body: JSON.stringify({quantity, line}),
          headers: {
              'Content-Type': 'application/json',
          },
      })
          .then((response) => response.json())
          .then(() => this.fetchCart())
          .catch((error) => {
              this.ajaxRequestFail();
              throw new Error(error);
          });
  }

  swapOutVariants(currentVariant, newVariant, currentQty) {
    window.fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ updates: { [currentVariant]: 0, [newVariant]: currentQty }}),
    })
      .then((response) => response.json())
      .then(() => this.fetchCart())
      .catch((error) => {
          this.ajaxRequestFail();
          throw new Error(error);
      });
  }

  cartItemCount(cart) {
      this.cartCount.innerHTML = cart.item_count;
  }

  updateShippingBar(cart) {
    let motivator = document.querySelector(".cart-shipping-bar");
    let bar = document.querySelector(this.freeShippingBar);
    let text = document.querySelector(this.shippingBarTxt);
    let cart_total = cart.total_price;
    let shipping_threshold = parseInt(motivator.getAttribute("data-shipping-threshold"));
    let gwp_threshold = parseInt(motivator.getAttribute("data-gwp-threshold"));
    let gwp_enabled = motivator.getAttribute("data-gwp-enabled")=="true";
    let message = motivator.getAttribute("data-unlocked");
    let perc = 100;
    let shortfall = 0;
 
    if (cart_total>gwp_threshold && gwp_enabled) {
      text.innerHTML = message;
      bar.style.width = "100%";
    } else {
      console.error("dewdewqdewqde",cart_total/shipping_threshold,(cart_total/shipping_threshold)*50);
      if (cart_total<shipping_threshold) {
        
        perc = (((cart_total/shipping_threshold))*50);
        shortfall = ((shipping_threshold-cart_total)/100).toFixed(2);
        message = motivator.getAttribute("data-shipping-message").replace("##amount",shortfall)
      } else {
        if (gwp_enabled) {
          perc = ((((cart_total-shipping_threshold)/(gwp_threshold-shipping_threshold))*100)/2)+50;
          shortfall = ((gwp_threshold-cart_total)/100).toFixed(2);
          message = motivator.getAttribute("data-gwp-message").replace("##amount",shortfall);
        } else {
          perc = 100;
          shortfall = 0;
          message = motivator.getAttribute("data-unlocked");
        }
      }
      text.innerHTML = message;
      bar.style.width = `${perc}%`;
    }

   /* 
    if (cart.total_price >= window.shipping_threshold*100) {
      document.querySelector(this.freeShippingBar).style.width='100%';
      document.querySelector(this.shippingBarTxt).innerHTML= 'FREE US SHIPPING';
    } else {
      var tillFreeShipping = (window.shipping_threshold*100) - parseInt(cart.total_price);
      document.querySelector(this.freeShippingBar).style.width=parseInt(cart.total_price/(window.shipping_threshold*100)*100) + "%";
      document.querySelector(this.shippingBarTxt).innerHTML = 'You are $' + parseFloat(tillFreeShipping / 100) + ' away from free US standard shipping.';
    }
    */
  }

  updateCartCountHeader(cart) {
    document.querySelector(this.cartCountNum).innerHTML=cart.item_count;
  }

	createCustomEmitter() {
		var detail = 'Cart Has Completed Fetching';
		try {
			// For modern browsers except IE:
			this.fetchCartComplete = new CustomEvent(this.defaults.fetchCartComplete, {detail:detail, bubbles: true});
		} catch(err) {
		
			// If IE 11 (or 10 or 9...?) do it this way:
			// Create the event.
			this.fetchCartComplete = document.createEvent('Event');
			this.fetchCartComplete.initEvent(this.defaults.fetchCartComplete, true, true);
			this.fetchCartComplete.detail = detail;
		}
	}

  fetchAndOpenCart() {
      this.fetchCart(() => {
          if (this.isDrawerMode) {
              this.openCartDrawer();
          } else {
              this.openMiniCart();
          }
          this.openCartOverlay();
      });
  }

  fetchAndOpenModal(product) {
      this.fetchCart(() => {
          this.renderCartModal(product);
          this.openCartModal();
          this.openCartOverlay();
      });
  }

  fetchHandler(cart, callback) {
      this.cartItemCount(cart);
      this.updateShippingBar(cart);
      this.updateCartCountHeader(cart);
      if (this.isDrawerMode) {
          if (cart.item_count === 0) {
              this.renderBlankCartDrawer();
              this.cartDrawerFooter.classList.add('is-invisible');
          } else {
              this.renderDrawerCart(cart);
              this.cartDrawerFooter.classList.remove('is-invisible');
              if ((typeof callback) === 'function') {
                  callback(cart);
              }
          }
      } else if (cart.item_count === 0) {
          this.renderBlankMiniCart();
          this.cartMiniCartFooter.classList.add('is-invisible');
      } else {
          this.renderMiniCart(cart);
          this.cartMiniCartFooter.classList.remove('is-invisible');
          if ((typeof callback) === 'function') {
              callback(cart);
          }
      }
  }

  addItemToCartHandler(product) {
      return this.displayModal ? this.fetchAndOpenModal(product) : this.fetchAndOpenCart();
  }

  ajaxRequestFail() {
      this.openFailModal();
      this.openCartOverlay();
  }

  renderCartModal(product) {
      this.clearCartModal();
      let productVariant = product.variant_title;
      if (productVariant === null) {
          productVariant = '';
      } else {
          productVariant = `(${productVariant})`;
      }
      const cartSingleProduct = `
      <div class="go-cart-modal-item">
          <div class="go-cart-item__image" style="background-image: url(${product.image});"></div>
          <div class="go-cart-item__info">
              <a href="${product.url}" class="go-cart-item__title">${product.product_title} ${productVariant}</a> ${this.labelAddedToCart}
          </div>
      </div>
    `;
      this.cartModalContent.innerHTML += cartSingleProduct;
  }

  renderDrawerCart(cart) {
      this.clearCartDrawer();
      cart.items.forEach((item, index) => {
        let additional_info = "";
        if (item.discounts && item.discounts.length>0) {
          additional_info = item.discounts[0].title;
        }
          // Free-gift lines keep their normal price but lock the quantity.
          const isGift = !!(item.properties && item.properties.free_products);
          const cartSingleProduct = `
      <div class="go-cart-item__single${isGift ? ' go-cart-item__single--gift' : ''}" data-line="${Number(index + 1)}">
          <div class="go-cart-item__info-wrapper">
              <div class="go-cart-item__image" style="background-image: url(${item.image});"></div>
              <div class="go-cart-item__info">
                  <a href="${item.url}" class="go-cart-item__title">${item.product_title}</a>
                  <div class="go-cart-item__variants-container">
                      <div class="go-cart-item__variant js-go-cart-item__variant" data-original-var-id="${item.id}" data-quantity="${item.quantity}" data-new-var-id="${item.variant_id}">
                          <div class="go-cart-item__dots selected"></div>
                          ${item.variant_title}
                      </div>
                  </div>
                  ${additional_info}
                  <div class="go-cart-item__quantity">
                    <span class="go-cart-item__quantity-label visually-hidden">${this.labelQuantity}</span>
                    ${isGift ? '' : `<span class="go-cart-item__quantity-button js-go-cart-quantity-minus">-</span>`}
                    <input class="go-cart-item__quantity-number js-go-cart-quantity" type="number" value="${item.quantity}" disabled>
                    ${isGift ? '' : `<span class="go-cart-item__quantity-button js-go-cart-quantity-plus">+</span>`}
                  </div>
              </div>
          </div>
          <div class="go-cart-item__price">${formatMoney(item.line_price, this.moneyFormat)}</div>
          <a class="go-cart-item__remove ${this.removeFromCartNoDot}">${this.labelRemove}</a>
      </div>
    `;
          this.cartDrawerContent.innerHTML += cartSingleProduct;
      });
      this.cartDrawerSubTotal.innerHTML = formatMoney(cart.total_price, this.moneyFormat);
      this.cartDrawerSubTotal.parentNode.classList.remove('is-invisible');
      const removeFromCart = document.querySelectorAll(this.removeFromCart);
      removeFromCart.forEach((item) => {
          item.addEventListener('click', () => {
              GoCart.removeItemAnimation(item.parentNode);
              const line = item.parentNode.getAttribute('data-line');
              this.removeItem(line);
          });
      });
      const itemQuantityPlus = document.querySelectorAll(this.itemQuantityPlus);
      itemQuantityPlus.forEach((item) => {
          item.addEventListener('click', () => {
              const line = item.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
              const quantity = Number(item.parentNode.querySelector(this.itemQuantity).value) + 1;
              this.changeItemQuantity(line, quantity);
          });
      });
      const itemQuantityMinus = document.querySelectorAll(this.itemQuantityMinus);
      itemQuantityMinus.forEach((item) => {
          item.addEventListener('click', () => {
              const line = item.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
              const quantity = Number(item.parentNode.querySelector(this.itemQuantity).value) - 1;
              this.changeItemQuantity(line, quantity);
              if (Number((item.parentNode.querySelector(this.itemQuantity).value - 1)) === 0) {
                  GoCart.removeItemAnimation(item.parentNode.parentNode.parentNode.parentNode);
              }
          });
      });

      const goCartItemVariant = document.querySelectorAll(this.goCartItemVariant);
      goCartItemVariant.forEach((item) => {
        item.addEventListener('click', () => {
          const originalVariantId = item.getAttribute("data-original-var-id");
          const newVariantId = item.getAttribute("data-new-var-id");
          const quantity = item.getAttribute("data-quantity");
          if(originalVariantId != newVariantId) {
            this.swapOutVariants(originalVariantId, newVariantId, quantity);
          }
        });
      });


			document.querySelectorAll('.js-go-cart-drawer .go-cart__button').forEach((element) => {
				element.classList.remove('is-invisible');
				element.removeAttribute('href');
				element.innerText = 'Checkout';
				
				element.addEventListener('click', (evt) => {
					evt.preventDefault();
					this.redirectToReChargeCheckout();
				});
			});

  }

  renderMiniCart(cart) {
      this.clearMiniCart();
      cart.items.forEach((item, index) => {
          let itemVariant = item.variant_title;
          if (itemVariant === null) {
              itemVariant = '';
          }
          // Free-gift lines keep their normal price but lock the quantity.
          const isGift = !!(item.properties && item.properties.free_products);
          const cartSingleProduct = `
      <div class="go-cart-item__single${isGift ? ' go-cart-item__single--gift' : ''}" data-line="${Number(index + 1)}">
          <div class="go-cart-item__info-wrapper">
              <div class="go-cart-item__image" style="background-image: url(${item.image});"></div>
              <div class="go-cart-item__info">
                  <a href="${item.url}" class="go-cart-item__title">${item.product_title}</a>
                  <div class="go-cart-item__variant"><span></span> ${itemVariant}</div>
                  <div class="go-cart-item__quantity">
                      <span class="go-cart-item__quantity-label">${this.labelQuantity} </span>
                      ${isGift ? '' : `<span class="go-cart-item__quantity-button js-go-cart-quantity-minus">-</span>`}
                      <input class="go-cart-item__quantity-number js-go-cart-quantity" type="number" value="${item.quantity}" disabled>
                      ${isGift ? '' : `<span class="go-cart-item__quantity-button js-go-cart-quantity-plus">+</span>`}
                  </div>
              </div>
          </div>
          <div class="go-cart-item__price">${formatMoney(item.line_price, this.moneyFormat)}</div>
          <a class="go-cart-item__remove ${this.removeFromCartNoDot}">${this.labelRemove}</a>
      </div>
    `;
          this.cartMiniCartContent.innerHTML += cartSingleProduct;
      });
      this.cartMiniCartSubTotal.innerHTML = formatMoney(cart.total_price, this.moneyFormat);
      this.cartMiniCartSubTotal.parentNode.classList.remove('is-invisible');
      const removeFromCart = document.querySelectorAll(this.removeFromCart);
      removeFromCart.forEach((item) => {
          item.addEventListener('click', () => {
              GoCart.removeItemAnimation(item.parentNode);
              const line = item.parentNode.getAttribute('data-line');
              this.removeItem(line);
          });
      });
      const itemQuantityPlus = document.querySelectorAll(this.itemQuantityPlus);
      itemQuantityPlus.forEach((item) => {
          item.addEventListener('click', () => {
              const line = item.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
              const quantity = Number(item.parentNode.querySelector(this.itemQuantity).value) + 1;
              this.changeItemQuantity(line, quantity);
          });
      });
      const itemQuantityMinus = document.querySelectorAll(this.itemQuantityMinus);
      itemQuantityMinus.forEach((item) => {
          item.addEventListener('click', () => {
              const line = item.parentNode.parentNode.parentNode.parentNode.getAttribute('data-line');
              const quantity = Number(item.parentNode.querySelector(this.itemQuantity).value) - 1;
              this.changeItemQuantity(line, quantity);
              if (Number((item.parentNode.querySelector(this.itemQuantity).value - 1)) === 0) {
                  GoCart.removeItemAnimation(item.parentNode.parentNode.parentNode.parentNode);
              }
          });
      });
  }

  renderBlankCartDrawer() {
      this.cartDrawerSubTotal.parentNode.classList.add('is-invisible');
      this.clearCartDrawer();
      this.cartDrawerContent.innerHTML = `<div class="go-cart__empty">${this.labelCartIsEmpty}</div>`;

      document.querySelectorAll('.js-go-cart-drawer .go-cart__button').forEach((element) => {
          element.classList.add('is-invisible');
      });
  }

  renderBlankMiniCart() {
      this.cartMiniCartSubTotal.parentNode.classList.add('is-invisible');
      this.clearMiniCart();
      this.cartMiniCartContent.innerHTML = `<div class="go-cart__empty">${this.labelCartIsEmpty}</div>`;
  }

  reloadAjaxContent() {
    this.fetchAndOpenCart();
  }

  clearCartDrawer() {
      this.cartDrawerContent.innerHTML = '';
  }

  clearMiniCart() {
      this.cartMiniCartContent.innerHTML = '';
  }

  clearCartModal() {
      this.cartModalContent.innerHTML = '';
  }

  openCartDrawer() {
      this.cartDrawer.classList.add('is-open');
  }

  closeCartDrawer() {
      this.cartDrawer.classList.remove('is-open');
  }

  openMiniCart() {
      this.cartMiniCart.classList.add('is-open');
  }

  closeMiniCart() {
      this.cartMiniCart.classList.remove('is-open');
  }

  openFailModal() {
      this.cartModalFail.classList.add('is-open');
  }

  closeFailModal() {
      this.cartModalFail.classList.remove('is-open');
  }

  openCartModal() {
      this.cartModal.classList.add('is-open');
  }

  closeCartModal() {
      this.cartModal.classList.remove('is-open');
  }

  openCartOverlay() {
      this.cartOverlay.classList.add('is-open');
  }

  closeCartOverlay() {
      this.cartOverlay.classList.remove('is-open');
  }

  static removeItemAnimation(item) {
      item.classList.add('is-invisible');
  }

  setDrawerDirection() {
      this.cartDrawer.classList.add(`go-cart__drawer--${this.drawerDirection}`);
  }

}


